/* ReportCenterSectionRenderer.js */

"use strict";

const ReportGeneratorEditorComponent = require("./editors/reportgeneratoreditor/ReportGeneratorEditorComponent");

class ReportCenterSectionRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("report-center-section-gl");
        this._rootElem.component = this._model;
        this._reportGeneratorCmpnt = undefined;

        this._registerListeners();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    shutdown() {
        this._unregisterListeners();
        let promArr = [Promise.resolve()];

        return Promise.all(promArr).then(() => {
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
        });
    }

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        if (!this._rootElem.hasChildNodes()) {
            this._reportGeneratorCmpnt = this._model.di.create(ReportGeneratorEditorComponent);
            this._rootElem.appendChild(this._reportGeneratorCmpnt.renderer.rootElement);
        }
        return this._reportGeneratorCmpnt.renderer.render();
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START PRIVATE RENDER METHODS            */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE RENDER METHODS              */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}

module.exports = ReportCenterSectionRenderer;
